import React, {Component} from 'react';
import UnitMap from "./UnitMap";
import {googleMapURL} from "../../../constants/googleMaps";
import {getUnitID} from "../utils";

/**
 * Live GPS tab wrapper
 */
class LiveGPSTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            long: 0,
            elev: null,
            error: null
        };
    }

    render() {
        return (
            <div key={getUnitID(this.props.selectedUnit)} className="gpsBackgroundDiv greyBackground">
                <div className="gpsContentDiv">
                    {
                        this.props.selectedUnit &&
                        <UnitMap
                            isMarkerShown
                            googleMapURL={googleMapURL}
                            loadingElement={<div style={{height: `100%`}} />}
                            containerElement={<div style={{height: 'calc(100vh - 250px)', minHeight: 150}} />}
                            mapElement={<div style={{height: `100%`}} />}
                            selectedUnit={this.props.selectedUnit}
                        />
                    }
                </div>
            </div>
        );
    }
}

export default LiveGPSTab;



// WEBPACK FOOTER //
// ./src/components/unit/livegps/LiveGPSTab.jsx